export default __webpack_public_path__ + "static/media/bernard_B.8058409e.svg";